import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../blockpay.css";
import Img from "../../images/login.png";
import Logo from "../../images/logo 01.png";
import AppStore from "../../images/App Store.svg";
import Gplay from "../../images/Google Play.svg";
import Grid from "@mui/material/Unstable_Grid2";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import { setAuthToken } from "../../utils/setAuthToken";
import Pin from "../SignUp/pin";
import { SHA256 } from "crypto-js";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Box,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Link } from "react-router-dom";
import GoogleImg from "../../images/google.png";
import AppleImg from "../../images/apple.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SmartPinModal from "./modals/smartPinModal";
import ForgotEmailModal from "./ForgotPassword/modals/emailModalFP"

export default function Login2Pass() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  // Modal use State
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Modal Use state for forgot password
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const navigate = useNavigate();
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const calculateHash = (inputValue) => {
    const hashedValue = SHA256(inputValue).toString();
    return hashedValue;
  };

  const handleMainLogoClick = () => {
    navigate("/");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("hello");
    axios
      .post("https://api.blockpay.co.za/merchant/login", {
        email: email,
        password: calculateHash(pass),
        issmartpin: false,
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res.data);
        localStorage.setItem("email", email);
        localStorage.setItem("name", res.data.name);
        localStorage.setItem("jwtToken", res.data.token);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        if (!res.data.smartPinExist) {
          handleOpen();
        } else {
          navigate("/dashboard", { replace: true });
        }

        setAuthToken(res.data.token);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          localStorage.clear();
          navigate("/signinpin", { replace: true });
        }
      });
  };
  
  return (
    <>
      <ToastContainer />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          "@media (max-width:900px)": {
            display: "flex",
            justifyContent: "center!important",
          },
        }}
      >
        <img
          src={Logo}
          className="loginLogoImg"
          onClick={handleMainLogoClick}
          style={{ cursor: "pointer" }}
        />
      </Box>
      <Grid container className="loginGrid">
        <Grid
          xs={12}
          md={5}
          lg={6}
          sx={{
            display: { xs: "none", md: "grid", lg: "flex" },
            justifyContent: "flex-end",
          }}
        >
          <img src={Img} className="loginImg" />
        </Grid>
        <Grid xs={12} md={7} lg={6} className="loginGridCol2">
          <Box className="loginCard">
            <CardContent>
              <Box
                sx={{
                  fontSize: "h4.fontSize",
                  fontWeight: "bold",
                  marginBottom: 2,
                }}
              >
                Log in
              </Box>
              <form onSubmit={handleSubmit}>
                <TextField
                  id="email"
                  className="logintextField"
                  label="Email address"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <TextField
                  className="logintextField"
                  label="Password"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Box
                          onClick={handleClickShowPassword}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          {showPassword ? (
                            <Button
                              sx={{
                                textTransform: "none",
                                color: "gray",
                                paddingRight: "0",
                              }}
                            >
                              <VisibilityOffIcon
                                fontSize="small"
                                sx={{ marginRight: "5px" }}
                              />
                              <Typography
                                sx={{
                                  fontWeight: "500",
                                }}
                              >
                                Hide
                              </Typography>
                            </Button>
                          ) : (
                            <Button
                              sx={{
                                textTransform: "none",
                                color: "gray",
                                paddingRight: "0",
                              }}
                            >
                              <VisibilityIcon
                                fontSize="small"
                                sx={{ marginRight: "5px" }}
                              />
                              <Typography
                                sx={{
                                  fontWeight: "500",
                                }}
                              >
                                Show
                              </Typography>
                            </Button>
                          )}
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => setPass(e.target.value)}
                  required
                />
                <Typography onClick={handleOpen2} component={Link} className="loginFPass" sx={{textTransform:"none", textDecoration:"none",display:"flex", justifyContent:"flex-end"}}>Forgot Password?</Typography>

                <Button
                  className="loginButton"
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  sx={{ textTransform: "none", borderRadius: "10px" }}
                  // disabled={!pass}
                >
                  Log in
                </Button>
                <SmartPinModal open={open} onClose={handleClose} />
                <ForgotEmailModal open={open2} onClose={handleClose2} />
              </form>
            </CardContent>
          </Box>
          <Box className="loginCard2">
            <CardContent sx={{ fontSize: 19, padding: "10px!important" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#666666",
                }}
              >
                <Box
                  component="img"
                  src={GoogleImg}
                  sx={{ height: "30px", marginRight: "1rem" }}
                />{" "}
                Continue with Google
              </Box>
            </CardContent>
          </Box>
          <Box className="loginCard2">
            <CardContent sx={{ fontSize: 19, padding: "10px!important" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#666666",
                }}
              >
                <Box
                  component="img"
                  src={AppleImg}
                  sx={{ height: "30px", marginRight: "1rem" }}
                />{" "}
                Continue with Apple
              </Box>
            </CardContent>
          </Box>
          <Box sx={{ fontSize: "19px", marginTop: "3rem" }}>
            Don't have an account?{" "}
            <span>
              <Link to="/signup" className="underline">
                Sign Up
              </Link>
            </span>
          </Box>
          <Box
            sx={{
              fontSize: "19px",
              marginTop: "2rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              background: "linear-gradient(90deg, #05B2FF 0%, #9340E2 70%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text, border",
              WebkitTextFillColor: "transparent",
              textDecoration: "underline blueviolet 1px!important",
              textUnderlinePosition: "under",
            }}
          >
            <Box
              component={Link}
              to="/signinpin"
              sx={{ display: "flex", mb: "10px" }}
            >
              <Typography sx={{ fontSize: "19px" }}>
                Log in with&nbsp;
              </Typography>
              <Typography sx={{ fontWeight: "500", fontSize: "19px" }}>
                Pin
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
